module.exports = __webpack_public_path__ + "static/media/undraw_confirmed_81ex.71ec60c5.svg";